<template>
    <div class='flex h-full' style='overflow: auto'>
        <div class='flex flex-col h-full' style='flex: 1; padding: 0 10px; min-width: 400px'>
            <div class='flex dop-header'>
                <tep-lookup
                    :value='selectedPeriod'
                    :meta='periodsMeta'
                    :data-source='store.state.tgrLookupYearsList'
                    @selected-value='onSelectPeriod'
                />
                <div :class='{"disabled-mode": isDisableCopy}'>
                    <dx-button hint='Скопировать графики с прошлого года'
                               :disabled='isDisableCopy'
                               :on-click='copyTgr' width='32px' height='32px'>
                        <img :src="'/infoenergo/assets/tep/tep-tree-menu/menu_item_1.svg'" alt='' class='w-full h-full' >
                    </dx-button>
                </div>
            </div>
            <div class='flex h-full w-full'>
                <ai-tree-list-edit
                    ref='treeTgrRef'
                    :meta="treeTgrMeta"
                    :args="treeTgrArgs"
                    :to-remove-toolbar-items-names="removeTreeToolbarItems"
                    @cell-click='onTgrClick'
                    @toolbar-button-click='onToolbarClick'
                    @refresh-end='refreshStoreData'
                    @user-data-changed='onUserDataChanged'
                >
                    <template #cellTemplate='{ data }'>
                        <div class="relative flex align-center" style='align-items: center'>
                            <div>
                                <component :is="data.data.kod_r == null ? 'ai-nsi-group-any-svg' : 'ai-nsi-node-svg'"
                                           class='tep-tree-icon' />
                            </div>
                            <div class='min-h-[16px] overflow-hidden'>
                                {{ data.displayValue }}
                            </div>
                        </div>
                    </template>
                </ai-tree-list-edit>
            </div>
        </div>
        <div class='flex flex-col h-full tep-snip-grid' style='flex: 2; min-width: 600px'>
            <template v-if='selectedTgrType === "root"'>
                <hr>
                <div class='tep-filled-root-header w-full'>
                    <div class='tep-header-item w-full flex dx-field'>
                        <div class='tep-header-label dx-field-label'>Наименование</div>
                        <div style='flex: 1' class='dx-field-value'>
                            <ai-text-box :value='tgrName'
                                         @input='(data) => onTgrDataChange("name", data.newText)'
                                         :disabled='disabledEditing'
                            ></ai-text-box>
                        </div>
                    </div>
                    <div class='tep-header-item w-full flex dx-field'>
                        <div class='tep-header-label dx-field-label'>
                            Температура наружного воздуха для проектирования отопления в местности
                        </div>
                        <div style='flex: 1' class='dx-field-value'>
                            <ai-text-box :value='tgrTnvSo'
                                         @input='(data) => onTgrDataChange("tnv_so", data.newText, "number")'
                                         :disabled='disabledEditing'
                            ></ai-text-box>
                        </div>
                    </div>
                    <div class='tep-header-item w-full flex dx-field'>
                        <div class='tep-header-label dx-field-label'>
                            Расчетная температура наружного воздуха для проектирования вентиляции
                        </div>
                        <div style='flex: 1' class='dx-field-value'>
                            <ai-text-box :value='tgrTnvSw'
                                         @input='(data) => onTgrDataChange("tnv_sw", data.newText, "number")'
                                         :disabled='disabledEditing'
                            ></ai-text-box>
                        </div>
                    </div>
                </div>
                <hr>
                <div class='text-xl tep-grid-name'>Температуры наружного воздуха</div>
                <hr>
                <ai-grid-edit
                    ref='gridTnvRef'
                    :meta='gridTnvMeta'
                    :args='gridTnvArgs'
                    :to-remove-toolbar-items-names='removeGridTnvToolbarItems'
                    @edit-grid-mounted='loadTnvGrid'
                ></ai-grid-edit>
            </template>
            <template v-else>
                <hr>
                <div class='tep-filled-root-header w-full flex tgr-child-cont'>
                    <div class='flex-col' style='flex: 3;'>
                        <div class='tep-header-item w-full flex dx-field'>
                            <div class='tep-header-label dx-field-label'>Отоп. период</div>
                            <div style='flex: 1' class='dx-field-value'>
                                <ai-text-box :value='tgrNamePasp'
                                             @input='(data) => onTgrDataChange("name_pasp", data.newText)'
                                             :disabled='disabledEditing'
                                ></ai-text-box>
                            </div>
                        </div>
                        <div class='flex like-tep-grid-1'>
                            <div class='flex-col' style='flex: 1'>
                                <div class='tep-header-item w-full flex dx-field'>
                                    <div class='dx-field-label'>Т1</div>
                                    <div class='dx-field-value'>
                                        <ai-number-box :value='tgrT1'
                                                     @input='(data) => onTgrDataChange("t1", data.newText, "number")'
                                                     :disabled='disabledEditing'
                                        ></ai-number-box>
                                    </div>
                                </div>
                                <div class='tep-header-item w-full flex dx-field'>
                                    <div class='dx-field-label'>Т1 ср. годовая</div>
                                    <div class='dx-field-value'>
                                        <ai-number-box :value='tgrT1sg'
                                                     @input='(data) => onTgrDataChange("t1_sg", data.newText, "number")'
                                                     :disabled='disabledEditing'
                                        ></ai-number-box>
                                    </div>
                                </div>
                            </div>
                            <div class='flex-col' style='flex: 1'>
                                <div class='tep-header-item w-full flex dx-field'>
                                    <div class='dx-field-label'>Т2</div>
                                    <div class='dx-field-value'>
                                        <ai-number-box :value='tgrT2'
                                                     @input='(data) => onTgrDataChange("t2", data.newText, "number")'
                                                     :disabled='disabledEditing'
                                        ></ai-number-box>
                                    </div>
                                </div>
                                <div class='tep-header-item w-full flex dx-field'>
                                    <div class='dx-field-label'>Т2 ср. годовая</div>
                                    <div class='dx-field-value'>
                                        <ai-number-box :value='tgrT2sg'
                                                     @input='(data) => onTgrDataChange("t2_sg", data.newText, "number")'
                                                     :disabled='disabledEditing'
                                        ></ai-number-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class='flex-col like-tep-grid-2' style='flex: 2;'>
                        <tep-lookup
                            :disabled='changeMode === "update"'
                            class='tep-header-item'
                            :value='kontur'
                            :meta='konturMeta'
                            :data-source='store.state.tgrLookupKonturList'
                            @selected-value='(value) => onTgrDataChange("kod_sxp", value, "number", 0)'
                        />
                        <tep-lookup
                            :disabled='changeMode === "update"'
                            class='tep-header-item'
                            :value='station'
                            :meta='stationMeta'
                            :data-source='store.state.tgrLookupStationList'
                            @selected-value='(value) => onTgrDataChange("kod_ist", value, "number", 0)'
                        />
                    </div>
                </div>
                <hr>
                <div class='h-full flex flex-col w-full'>
                    <div class='flex'>
                        <div :class='{
                                "ai-tab-bar-item-selected": selectedTab === "waterTemp",
                                "ai-tab-bar-item": selectedTab !== "waterTemp"
                            }'
                            @click='() => changeTab("waterTemp")'>
                            <div class='ai-tab-bar-item-title'>Утвержденные температуры</div>
                        </div>
                        <div :class='{
                                "ai-tab-bar-item-selected": selectedTab === "snip",
                                "ai-tab-bar-item": selectedTab !== "snip"
                            }'
                            @click='() => changeTab("snip")'>
                            <div class='ai-tab-bar-item-title'>Температуры теплоносителя</div>
                        </div>
                    </div>
                    <hr>
                    <div v-show='selectedTab === "waterTemp"'
                         class='h-full flex flex-col w-full'>
                        <div class='text-xl tep-grid-name'>Утвержденные температуры сетевой воды со станции</div>
                        <ai-grid-edit
                            ref='gridTempRef'
                            :meta='gridTempMeta'
                            :args='gridTempArgs'
                            :to-remove-toolbar-items-names='removeGridToolbarItems'
                            @edit-grid-mounted='loadTempGrid'
                        ></ai-grid-edit>
                    </div>
                    <div v-show='selectedTab === "snip"'
                         class='h-full flex flex-col w-full'>
                        <div class='text-xl tep-grid-name'>Температуры теплоносителя, приведенные к tнар.воздуха из СНИП</div>
                        <ai-grid-ro
                            ref='gridSnipRef'
                            :meta='gridSnipMeta'
                            :args='gridSnipArgs'
                            :to-remove-toolbar-items-names='removeGridToolbarItems'
                        />
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import { DxButton } from 'devextreme-vue';
import { dxUiNotify } from '@/utils/dx-helper';
import store from '@/views/tep/tep-nsi/store/tep-nsi-store';
import AiTextBox from '@/components/ai-text-box.vue';
import TepLookup from '@/views/tep/tep-nsi/components/tep-lookup.vue';
import { getCookie } from '@/utils/cookies';
import tepService from '@/service/tep-service';
import AiNumberBox from '@/components/ai-number-box.vue';

const props = defineProps({
    fromCard: {
        type: Boolean,
        default: () => false,
    }
})
const emits = defineEmits(['choose-tgr'])

// region variables
const treeTgrRef = ref();
const gridTempRef = ref();
const gridSnipRef = ref();
const gridTnvRef = ref();

const selectedTgrType = ref('root'); // 'child'
const selectedTab = ref('waterTemp'); // 'snip'
const selectedTgrKod = ref(-1);
const changeMode = ref('update'); // 'insert'
const selectedTgrRow = ref(null);
const isTgrChosen = ref(false);

const removeDefaultTreeToolbarItems = ['export', 'settings', 'show-column-chooser', 'searchPanel', 'copy', 'edit',
    'expandOrCollapseButton', 'moveSave', 'moveTo', 'find-prev', 'find', 'find-start', 'find-next', 'cut', 'put'];
const removeTreeToolbarItems = ref(removeDefaultTreeToolbarItems);
if (!props.fromCard) removeTreeToolbarItems.value.push('choice');

const treeTgrMeta = {
    keyExpr: 'kod',
    api: {
        select: 'tep-grid./tep/tgr-tree-data/get',
        save: 'tep-grid./tep/tgr-tree-save/set'
    },
    wordWrapEnabled: true,
    allowColumnResizing: false,
    viewId: 'qs-temp-gr-tree',
    parentIdExpr: 'kod_r',
    selectButtonMode: 'single',
    selectionMode: 'single',
    maxWidth: "w-full",
    columns: [
        {
            caption: '',
            name: 'kod',
            dataField: 'kod',
            visible: false,
            index: 1,
            allowEditing: false,
        },
        {
            caption: 'График',
            name: 'name',
            dataField: 'name',
            visible: true,
            index: 2,
            allowEditing: false,
            cellTemplate: 'cellTemplate'
        }
    ]
}
const defaultTgrArgs = {select: {year: 1}};
const treeTgrArgs = ref(defaultTgrArgs);

const selectedPeriod = ref(null);
const periodsMeta = {
    keyExpr: 'year',
    api: {select: 'tep-grid./tep/tgr-years-list/get'},
    wordWrapEnabled: true,
    fieldNameText: "year_name",
    fieldNameId: "year",
    hasntRoute: true,
    columns: [
        {
            caption: '',
            name: 'year',
            dataField: 'year',
            visible: false,
            width: 50,
            index: 1,
        },
        {
            caption: '',
            name: 'year_name',
            dataField: 'year_name',
            visible: true,
            index: 2,
            allowFiltering: false
        },
    ],
    viewId: "qs-temp-gr-years"
}

const konturMeta = {
    title: 'Тип темп. гр.',
    keyExpr: 'kod_sxp',
    api: {select: 'tep-grid./tep/tgr-lookup-kontur/get'},
    wordWrapEnabled: true,
    fieldNameText: "name",
    fieldNameId: "kod_sxp",
    hasntRoute: true,
    columns: [
        {
            caption: '',
            name: 'kod_sxp',
            dataField: 'kod_sxp',
            visible: false,
            width: 50,
            index: 1,
        },
        {
            caption: '',
            name: 'name',
            dataField: 'name',
            visible: true,
            index: 2,
            allowFiltering: false
        },
    ],
    viewId: "qs-temp-gr-kontur"
}
const stationMeta = {
    title: 'Источник',
    keyExpr: 'kod',
    api: {select: 'tep-grid./tep/tgr-lookup-st/get'},
    wordWrapEnabled: true,
    fieldNameText: "name",
    fieldNameId: "kod",
    hasntRoute: true,
    columns: [
        {
            caption: '',
            name: 'kod',
            dataField: 'kod',
            visible: false,
            width: 50,
            index: 1,
        },
        {
            caption: '',
            name: 'name',
            dataField: 'name',
            visible: true,
            index: 2,
            allowFiltering: false
        },
    ],
    viewId: "qs-temp-gr-station"
}

const removeGridToolbarItems = ['choice', 'searchPanel', 'edit', 'show-column-chooser'];
const gridTempMeta = {
    "keyExpr": "tnv",
    "columns": [
        {
            "name": "tnv",
            "caption": "Темп-ра наружного воздуха, tн.в. С°",
            "dataField": "tnv",
            "allowEditing": true,
            "width": '33.3%',
            "index": 1,
            "visible": true,
            'dataType': 'number',
        },
        {
            "name": "t1",
            "caption": "Темп-ра в подающем трубопроводе, t1 С°",
            "dataField": "t1",
            "allowEditing": true,
            "width": '33.3%',
            "index": 2,
            "visible": true,
            'dataType': 'number',
        },
        {
            "name": "t2",
            "caption": "Темп-ра в обратном трубопроводе, t2 С°",
            "dataField": "t2",
            "allowEditing": true,
            "width": '33.3%',
            "index": 3,
            "visible": true,
            'dataType': 'number',
        },
    ],
    "api": {
        "select": "tep-nsi./tep-nsi/qs-tempgr-st/select/get",
        "save": "tep-nsi./tep-nsi/qs-tempgr-st/save/set"
    },
    "viewId": "view-qs-tempgr-st"
}
const defaultSaveArgs = {kod_tgr: -1, kod_ist: -1, dep: +getCookie('dep')};
const defaultGridTempArgs = {
    select: {
        select_args: {kod_tgr: -1}
    },
    save: {
        update_args: {...defaultSaveArgs},
        insert_args: {...defaultSaveArgs},
        delete_args: {...defaultSaveArgs}
    }
}
const gridTempArgs = ref(defaultGridTempArgs);

const gridSnipMeta = {
    "keyExpr": "kod_period",
    "api": {
        "select": "tep-grid./tep/tgr-inter-periods/get"
    },
    "viewId": "qs-tgr-inter-periods",
    columns: [
        {
            "name": "kod_period",
            "caption": "Код",
            "dataField": "kod_period",
            "width": 100,
            "index": 1,
            "visible": false
        },
        {
            "name": "name",
            "caption": "Период",
            "dataField": "name",
            "width": 200,
            "index": 2,
            "visible": true
        },
        {
            "name": "t1",
            "caption": "T1 max\nС°",
            "dataField": "t1",
            "width": 200,
            "index": 3,
            "visible": true
        },
        {
            "name": "t2",
            "caption": "T2 max\nС°",
            "dataField": "t2",
            "width": 200,
            "index": 4,
            "visible": true
        },
        {
            "name": "tnv",
            "caption": "Среднемесячная темп-ра\nС°",
            "dataField": "tnv",
            "width": 200,
            "index": 5,
            "visible": true
        },
        {
            "name": "empty",
            "caption": "",
            "dataField": "empty",
            "index": 6,
            "visible": true
        }
    ]
}
const defaultGridSnipArgs = {kod_tgr: -1};
const gridSnipArgs = ref(defaultGridSnipArgs);

const removeGridTnvToolbarItems = ['choice', 'searchPanel', 'edit', 'show-column-chooser', 'add', 'copy', 'delete'];
const gridTnvMeta = {
    "keyExpr": "id_period",
    "selectionMode": "single",
    "columns": [
        {
            "name": "id_period",
            "caption": "id_period",
            "dataField": "id_period",
            "allowEditing": false,
            "width": 200,
            "index": 1,
            "visible": false
        },
        {
            "name": "name_period",
            "caption": "Наименование месяца",
            "dataField": "name_period",
            "allowEditing": false,
            "width": 200,
            "index": 2,
            "visible": true
        },
        {
            "name": "tnv",
            "caption": "Среднемесячная температура",
            "dataField": "tnv",
            "allowEditing": true,
            "width": 200,
            "index": 3,
            "visible": true
        },
        {
            "name": "empty",
            "caption": "",
            "dataField": "empty",
            "allowEditing": false,
            "index": 4,
            "visible": true
        }
    ],
    "api": {
        "select": "tep-grid./tep/tgr-snip-periods/get",
        "save": "tep-grid./tep/tgr-snip-periods/set"
    },
    "viewId": "qs-tgr-snip-grid"
}
const defaultGridTnvArgs = {select: {kod_tgr: -1}};
const gridTnvArgs = ref(defaultGridTnvArgs);

const tgrName = computed(() => tgrValue('name'))
const tgrNamePasp = computed(() => tgrValue('name_pasp'))
const tgrTnvSo = computed(() => tgrValue('tnv_so'))
const tgrTnvSw = computed(() => tgrValue('tnv_sw'))
const tgrT1 = computed(() => tgrValue('t1'))
const tgrT2 = computed(() => tgrValue('t2'))
const tgrT1sg = computed(() => tgrValue('t1_sg'))
const tgrT2sg = computed(() => tgrValue('t2_sg'))
const kontur = computed(() => tgrValue('kod_sxp'))
const station = computed(() => tgrValue('kod_ist'))

const disabledEditing = computed(() => selectedTgrKod.value === -1)
const isDisableCopy = computed(() => selectedPeriod.value === null || store.state.tgrTreeList.length > 0)

const inputTimer = ref(null);
// endregion

// region help functions
const tgrValue = (field) => {
    if (changeMode.value === 'update') {
        const rowData = store.state.tgrTreeList.filter(el => el.kod === selectedTgrKod.value);
        return rowData.length > 0 ? rowData[0][field] : null
    } else {
        const currChangesState = [...treeTgrRef.value.treeListInstance.option('editing.changes')];
        const rowData = currChangesState.find(el => el.key === selectedTgrRow.value)?.data;
        return rowData ? rowData[field] : null
    }
}

const refreshStoreData = async () => {
    store.state.tgrTreeList = await treeTgrRef.value?.getTreeListDataSource(0);
    await buttonsStateChange();
}

const refreshDataFromServer = async () => {
    await treeTgrRef.value?.setDataSource(null, treeTgrArgs.value.select);
    await refreshStoreData();
    treeTgrRef.value?.expandAll();
}

const changeTab = (tabName) => {
    selectedTab.value = tabName;
}

const buttonsStateChange = () => {
    setTimeout(async () => {
        const buttonsRefs = await treeTgrRef.value?.getButtonsRefs();
        if (!buttonsRefs || !buttonsRefs.value) return;
        buttonsRefs.value['isChoiceButtonDisabled'] =
            !(store.state.tgrTreeList.length > 0 && treeTgrRef.value.treeListInstance.option('focusedRowIndex') >= 0);
        if (buttonsRefs.value['isSaveButtonDisabled'] === false) {
            buttonsRefs.value['isAddChildButtonDisabled'] = true
            buttonsRefs.value['isAddSiblingButtonDisabled'] = true
            buttonsRefs.value['isDeleteButtonDisabled'] = true
        } else {
            buttonsRefs.value['isAddChildButtonDisabled'] =
                store.state.tgrTreeList.filter(el => el.kod_r === null).length === 0;
            buttonsRefs.value['isAddSiblingButtonDisabled'] = false
            buttonsRefs.value['isDeleteButtonDisabled'] =
                !(store.state.tgrTreeList.length > 0
                    && treeTgrRef.value.treeListInstance.option('focusedRowIndex') >= 0
                    && store.state.tgrTreeList.filter(el => el.kod_r === selectedTgrKod.value).length === 0);
        }
    }, 100);
}

const beforeInsertRow = async (insertEvent) => {
    let canInsert = true;
    let errMsg = '';
    const period = store.state.tgrLookupYearsList.find(el => el.year === selectedPeriod.value);

    const newItemData = {...insertEvent.data}
    const parentId = newItemData.kod_r;
    if (parentId) {
        const parentData = store.state.tgrTreeList.find(el => el.kod === parentId);
        if (parentData?.kod_r) {
            canInsert = false;
            errMsg = 'Нельзя добавить строку более чем на 2 уровень';
        }
    } else if (store.state.tgrTreeList.find(el => el.kod_r === null)) {
        canInsert = false;
        errMsg = `СНИП для ${period?.year_name ?? 'выбранного периода' } уже добавлен`;
    }

    // а теперь делаем то, что надо, в зависимости от результата проверки родителя
    if (!canInsert) {
        dxUiNotify(errMsg, 'error');
        await treeTgrRef.value.refreshClick([], [], true);
        await refreshDataFromServer();
        treeTgrRef.value.setFocusdRow(selectedTgrRow.value);
    } else {
        if (newItemData.kod_r == null) {
            selectedTgrType.value = 'root';
            newItemData.name = `СНИП ${period?.year_name}`;
        } else {
            selectedTgrType.value = 'child';
            newItemData.name = period?.year_name;
            newItemData.name_pasp = period?.year_name;
            newItemData.kod_sxp = store.state.tgrLookupKonturList[0].kod_sxp;
            newItemData.kod_ist = store.state.tgrLookupStationList[0].kod;
        }
        newItemData.year = period?.year;

        setTimeout(() => {
            const changes = [{...insertEvent, data: {...newItemData}}];
            treeTgrRef.value.treeListInstance.option('editing.changes', changes);

            selectedTab.value = 'waterTemp';
            selectedTgrKod.value = newItemData.kod;
            changeMode.value = 'insert';
            selectedTgrRow.value = insertEvent.key;
        }, 200) // делаю так, чтобы оно пришло вовремя
    }
}

const processingNewData = (textData, dataType) => {
    let newData = textData;
    if (dataType === "number") {
        if (newData === '') {
            newData = null // чтобы если должно быть пусто, чтобы было пусто, а не 0
        } else if (!isNaN(Number(newData))) {
            newData = Number(newData);
        }
    }
    return newData;
}

const updateTgr = async (field, textData, dataType, delay) => {
    let originValue = null;
    const newData = processingNewData(textData, dataType);
    for (const item of store.state.tgrTreeList) {
        if (item.kod === selectedTgrKod.value) {
            const originValues = store.state.tgrTreeListOriginValues.filter(el => el.kod === item.kod);
            if (originValues.length === 0) {
                store.state.tgrTreeListOriginValues.push({...item});
                originValue = item[field];
            } else {
                originValue = originValues[0][field];
            }
            item[field] = newData;
            break;
        }
    }
    clearTimeout(inputTimer.value);
    inputTimer.value = setTimeout(async () => {
        await treeTgrRef.value?.setDataSource(store.state.tgrTreeList);
        treeTgrRef.value?.updateChanges(selectedTgrKod.value, field, newData, originValue);
        await buttonsStateChange();
    }, delay);
}

const updateNewTgr = async (field, textData, dataType, delay) => {
    const newData = processingNewData(textData, dataType);
    clearTimeout(inputTimer.value);
    inputTimer.value = setTimeout(async () => {
        const currChangesState = [...treeTgrRef.value.treeListInstance.option('editing.changes')];
        try {
            currChangesState.find(el => el.key === selectedTgrRow.value).data[field] = newData;
        } catch (err) {
            console.error('currChangesState set data error: ', err);
        }
        treeTgrRef.value.treeListInstance.option('editing.changes', currChangesState);
    }, delay);
}

const setDefaultState = () => {
    treeTgrRef.value.setFocusdRow(-1);
    selectedTgrType.value = 'root';
    selectedTab.value = 'waterTemp';
    selectedTgrKod.value = -1;
    changeMode.value = 'update';
    selectedTgrRow.value = null;
    loadGridData();
}

const loadTempGrid = () => {
    const saveArgs = {...defaultSaveArgs};
    saveArgs.kod_tgr = selectedTgrKod.value;
    saveArgs.kod_ist = station.value;

    const newArgs = {...defaultGridTempArgs};
    newArgs.select.select_args.kod_tgr = selectedTgrKod.value;
    newArgs.save.insert_args = {...saveArgs};
    newArgs.save.update_args = {...saveArgs};
    newArgs.save.delete_args = {...saveArgs};
    gridTempArgs.value = {...newArgs};

    setTimeout(() => {
        gridTempRef.value?.setDataSource();
    }, 10);
}

const loadSnipGrid = () => {
    const newArgs = {...defaultGridSnipArgs};
    newArgs.kod_tgr = selectedTgrKod.value;
    gridSnipArgs.value = {...newArgs};

    setTimeout(() => {
        gridSnipRef.value?.setDataSource();
    }, 10);
}

const loadTnvGrid = () => {
    const newArgs = {...defaultGridTnvArgs};
    newArgs.select.kod_tgr = selectedTgrKod.value;
    gridTnvArgs.value = {...newArgs};

    setTimeout(() => {
        gridTnvRef.value?.setDataSource();
    }, 10);
}

const loadGridData = async () => {
    if (selectedTgrType.value === 'root') {
        loadTnvGrid();
    } else {
        loadTempGrid();
        loadSnipGrid();
    }
}

const checkBeforeClose = async () => {
    let canClose = await treeTgrRef.value?.checkBeforeClose();
    if (canClose === false) return false;
    canClose = await gridTempRef.value?.checkBeforeClose();
    if (canClose === false) return false;
    canClose = await gridTnvRef.value?.checkBeforeClose();
    return canClose !== false;
}

const beforeNsiClose = async () => {
    const canClose = await checkBeforeClose();
    if (!canClose) return false;

    const tgrItem = store.state.tgrTreeList.find(item => item.kod === selectedTgrKod.value);
    emits('choose-tgr', tgrItem, isTgrChosen.value);
    onSelectPeriod(null).then() // обнуляем представление
}
// endregion

// region events handlers
const onStart = () => {
    setTimeout(async () => {
        if (store.state.tgrLookupYearsList.length === 0)
            await store.loadTgrLookupYearsList();
        if (store.state.tgrLookupKonturList.length === 0)
            await store.loadTgrLookupKontur();
        await store.loadTgrLookupStation(); // зависит от департамента, поэтому будем перезаписывать при входе в справочник
        buttonsStateChange();
    }, 200)
}

onMounted(() => {
    onStart();
})

const onSelectPeriod = async (year) => {
    selectedPeriod.value = year;
    const newTreeArgs = {...defaultTgrArgs};
    // если у нас не выбран период, то посылаем год = 1, чтобы ничего не выводилось
    newTreeArgs.select.year = selectedPeriod.value === null ? 1 : selectedPeriod.value;
    treeTgrArgs.value = newTreeArgs;
    await refreshDataFromServer();
    setDefaultState();
}

const copyTgr = async () => {
    await tepService.setTgrCopyLastYear(selectedPeriod.value);
    await refreshDataFromServer();
    setDefaultState();
}

const onTgrClick = async (event) => {
    const canContinue = await checkBeforeClose();
    const buttonsRefs = await treeTgrRef.value?.getButtonsRefs();
    if (buttonsRefs.value['isSaveButtonDisabled'] === false) {
        if (!canContinue) {
            // возвращаем фокус на предыдущую строку
            treeTgrRef.value.treeListInstance.clearSelection();
            treeTgrRef.value.setFocusdRow(selectedTgrRow.value);
        } else {
            await refreshDataFromServer();
            treeTgrRef.value.setFocusdRow(event.key);
        }
    }
    if (canContinue) {
        selectedTgrRow.value = event.key;
        let rowData = store.state.tgrTreeList.filter(el => el.kod === event.key);
        if (rowData.length > 0) {
            selectedTgrKod.value = rowData[0].kod;
            selectedTgrType.value = rowData[0].kod_r == null ? 'root' : 'child';
        }
        await loadGridData();
    }
    await buttonsStateChange();
}

const onTgrDataChange = async (field, textData, dataType = "string", delay = 1000) => {
    if (changeMode.value === 'update') {
        await updateTgr(field, textData, dataType, delay);
    } else {
        await updateNewTgr(field, textData, dataType, delay);
    }
}

const onToolbarClick = async (event) => {
    await buttonsStateChange();
    const componentName = event?.item?.component?.name;
    if (componentName === 'choice') {
        isTgrChosen.value = true;
        await beforeNsiClose();
    } else if (componentName === 'delete' || componentName === 'save' || componentName === 'refresh') {
        // сбрасываем все до начального состояния
        setDefaultState();
    }
}

const onUserDataChanged = async (event) => {
    const insertEventData = event.treeListChanges?.filter(el => el.type === 'insert') ?? [];
    for (const insertEvent of insertEventData) {
        await beforeInsertRow(insertEvent)
    }
}
// endregion

defineExpose({
    beforeNsiClose: beforeNsiClose,
    onStart: onStart
})
</script>

<style scoped>
.dop-header {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
.dop-header :deep(.dx-field) {
    margin: 0;
    width: 90%;
}
.dop-header :deep(.dx-field-value) {
    width: 100% !important;
}
.tep-filled-root-header {
    padding: 10px 0;
}
.tep-grid-name {
    width: 100%;
    text-align: center;
    padding: 10px 0;
}
.tep-snip-grid hr {
    color: #03142577;
}
.tep-tree-icon {
    width: auto;
    height: 1.5em;
    margin-right: 10px;
}
.tep-header-item/*, .tep-header-item :deep(.dx-field)*/ {
    align-items: center;
    margin-bottom: 10px;
    padding-right: 20px;
}
.tep-header-label {
    width: fit-content;
}
.like-tep-grid-1 .dx-field-label {
    flex: 2;
}
.like-tep-grid-2 :deep(.dx-field-label) {
    flex: 1;
}
.like-tep-grid-1 .dx-field-value, .like-tep-grid-2 :deep(.dx-field-value) {
    flex: 3;
}
.ai-tab-bar-item, .ai-tab-bar-item-selected {
    padding: 3px 12px;
}
.disabled-mode {
    opacity: 0.5;
}
</style>
